import { Injectable } from '@angular/core';
import { RicercaBean } from '../models/ricerca/ricerca-bean';

@Injectable()
export class SearchCacheService {
  public lastSearch: RicercaBean;
  public searchSmart: RicercaBean

}
